import React from 'react'
import image from "./../images/logo.png"
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react'
import whatsapp from "./../images/whatsapp-svgrepo-com.png"

function Footer() {
    return (
        <section className="py-0 bg-1000">
            <div className="container">
                <div className="row py-7">
                    <div className="col-12 col-sm-12 col-lg-6 mb-4 order-0 order-sm-0">
                        <a className="text-decoration-none" href="/"><img src={image} height="51" alt="" /></a>
                        <p className="text-light mt-3">GH: +233(25)612-1731</p>
                        <p className="text-light mt-3">GH: +233(25)612-1730</p>
                        <p className="text-light mt-2">info@hustleconnects.com</p>
                        <div className="d-flex">
                            <a href="https://www.linkedin.com/in/hustle-connects-69591037b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
                                <Linkedin style={{marginRight: 10, color: '#D1B000'}} />
                            </a>
                            <a href="https://www.facebook.com/share/1BLApL5Gof/?mibextid=wwXIfr">
                                <Facebook style={{marginRight: 10, color: '#D1B000'}} />
                            </a>
                            <a href="https://whatsapp.com/channel/0029Vb6QiKuJENy0qg4Jg209">
                                <img src={whatsapp} style={{marginRight: 10, color: '#D1B000'}} height={25} width={25} />
                            </a>
                            <a href="https://www.instagram.com/hustleconnects/profilecard/?igsh=MXdkZjc2dTlscTQ4cw==">
                                <Instagram style={{marginRight: 10, color: '#D1B000'}} />
                            </a>
                        </div>
                    </div> 
                    <div className="col-3 col-sm-4 col-lg-2 mb-3 order-2 order-sm-1">
                        <h5 className="lh-lg fw-bold text-light font-sans-serif">Quick Links</h5>
                        <ul className="list-unstyled text-light mb-md-4">
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/#home">Home</a></li>
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/#about">About</a></li>
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/#services">Services</a></li>
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/#whyus">Why Choose Us</a></li>
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/faqs">FAQs</a></li>
                        </ul>
                    </div>
                    <div className="col-6 col-sm-4 col-lg-2 mb-3 order-3 order-sm-2">
                        <h5 className="lh-lg fw-bold text-light font-sans-serif">Company</h5>
                        <ul className="list-unstyled text-light mb-md-4 mb-lg-0">
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/careers">Careers</a></li>
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/">Resources</a></li>
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/waiting">Join WaitList</a></li>
                        </ul>
                    </div>
                    <div className="col-6 col-sm-4 col-lg-2 mb-3 order-3 order-sm-2">
                        <h5 className="lh-lg fw-bold text-light font-sans-serif">Support</h5>
                        <ul className="list-unstyled text-light mb-md-4 mb-lg-0">
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/terms-of-use">Terms of Use</a></li>
                            <li className="lh-lg"><a className="text-500 footer-link text-light" href="/privacy-policy">Privacy Policy</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <section className="py-0 bg-1000">
                <div className="container">
                    <div className="row justify-content-md-between justify-content-evenly py-3">
                        <div className="col-12 col-sm-12 align-items-center">
                            <p className="fs--1 my-2 fw-bold text-200 text-center">&copy; 2026 HustleConnects</p>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    )
}

export default Footer
